export default [{
    path: '/doc',
    name: '文档',
    redirect: '/doc/sdk',
    component: resolve => require(['@/page/docs'], resolve),
    children: [
        {
            path: 'api',
            name: 'api',
            component: resolve => require(['@/page/docs/api'], resolve),
            meta: {
                title: 'api文档'
            },
        },
        {
            path: 'sdk',
            name: 'sdk',
            component: resolve => require(['@/page/docs/androidsdk'], resolve),
            meta: {
                title: 'sdk文档'
            },
        }
    ]
}]


// WEBPACK FOOTER //
// ./src/router/doc.js